import { ReactComponent as UnlockSvg } from "assets/unlock.svg";
import { useContext } from "react";
import { UserContext } from "store";

// style
import "./style.scss";

const TravelPartnerBanner = () => {
	const { state } = useContext(UserContext);
	const { currentUser } = state;

	return null;
	return (
		<>
			{currentUser.isTravelAgent ? (
				<div className="ta-banner__container">
					<div className="ta-banner__wrapper">
						<UnlockSvg />
						<h2 className="ta-banner__heading">
							Your Travel Partner coupon code
						</h2>
						<UnlockSvg />
						<h3 className="ta-banner__coupon-code">{currentUser.couponCode}</h3>
						<p className="ta-banner__info">Avail 10% off (max 15%)</p>
					</div>
				</div>
			) : null}
		</>
	);
};

export default TravelPartnerBanner;
